import { render } from "./OnScreenKeyboard.vue?vue&type=template&id=1dd12f10&scoped=true"
import script from "./OnScreenKeyboard.vue?vue&type=script&lang=js"
export * from "./OnScreenKeyboard.vue?vue&type=script&lang=js"

import "./OnScreenKeyboard.vue?vue&type=style&index=0&id=1dd12f10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd12f10"]])

export default __exports__